import { addDays, isAfter } from 'date-fns';
import { getDateInRequestFormat } from './dateUtil';

export const formatStartDateWithoutMilliseconds = (startDate: Date): string => {
  return getDateInRequestFormat(startDate, [startDate.getHours(), 0, 0], {
    milliseconds: false,
  });
};

export const formatEndDateWithoutMilliseconds = (endDate: Date, startDate: Date): string => {
  const newDate = addDays(endDate, isAfter(startDate, endDate) ? 1 : 0);

  return getDateInRequestFormat(newDate, [23, 59, 59], { milliseconds: false });
};
